type PlatformUser =
  | {
      id?: string;
      profile?: {
        name?: string;
        email?: string;
      };
    }
  | null
  | undefined;

/**
 * Name to store on a clinic survey response. Prefer the platform profile
 * name. Otherwise use the local part of a @fountainlife.com email.
 */
export function platformUserLabel(user: PlatformUser): string {
  const name = user?.profile?.name?.trim();
  if (name) return name;

  const email = user?.profile?.email?.trim();
  if (!email) return '';
  const at = email.lastIndexOf('@');
  if (at <= 0) return '';
  const local = email.slice(0, at);
  const domain = email.slice(at + 1).toLowerCase();
  if (domain !== 'fountainlife.com' || !local) return '';
  return local;
}

export function platformUserAuthor(user: PlatformUser): {
  reference?: string;
  display: string;
} {
  return {
    reference: user?.id,
    display: platformUserLabel(user),
  };
}
